import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from "react";
import axios from "axios";
import { emitMigrationFlashMessageImpression } from "@catchoftheday/analytics";
import { Link, Span } from "@catchoftheday/cg-components";
import { ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY, ONEPASS_ELIGIBLE_FOR_MIGRATION_PARAM_KEY, ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY } from "@catchoftheday/onepass";
import { FLASH_BANNER_MIGRATION_ERROR_MSG, FLASH_BANNER_MIGRATION_SUCCESS_DOUBLE_SUB_MSG, FLASH_BANNER_MIGRATION_SUCCESS_MSG, FLASH_BANNER_NOT_ELIGIBLE_FOR_ONEPASS_MIGRATION_MSG } from "@header/consts";
import { getQueryStringValue } from "@header/utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var getCountryDataMessage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var isMicrofrontend,
        _yield$axios$get,
        _yield$axios$get$data,
        userCountryName,
        shouldShopUrl,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isMicrofrontend = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;

            if (isMicrofrontend) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", null);

          case 3:
            _context.next = 5;
            return axios.get("/country.json");

          case 5:
            _yield$axios$get = _context.sent;
            _yield$axios$get$data = _yield$axios$get.data;
            userCountryName = _yield$axios$get$data.userCountryName;
            shouldShopUrl = _yield$axios$get$data.shouldShopUrl;

            if (!(userCountryName && shouldShopUrl)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", {
              theme: "light",
              variant: "info",
              message: ___EmotionJSX(Span, {
                fontSize: {
                  xs: "base",
                  lg: "xl"
                },
                m: "auto"
              }, "Hi, it looks like you're in ", userCountryName, ", we suggest you shop on", " ", ___EmotionJSX(Link, {
                color: "#000",
                textDecoration: "underline",
                href: "https://".concat(shouldShopUrl, "/")
              }, shouldShopUrl), " ", "instead.")
            });

          case 11:
            return _context.abrupt("return", null);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCountryDataMessage() {
    return _ref.apply(this, arguments);
  };
}();
export var getOnePassMigrationMessage = function getOnePassMigrationMessage() {
  var isMicrofrontend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var paramMigrationDoubleSubs = getQueryStringValue(ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY);
  var paramMigrationStatus = getQueryStringValue(ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY);
  var paramEligibleForMigration = getQueryStringValue(ONEPASS_ELIGIBLE_FOR_MIGRATION_PARAM_KEY);

  if (paramEligibleForMigration === "0") {
    return {
      theme: "light",
      variant: "warning",
      showIcon: true,
      message: FLASH_BANNER_NOT_ELIGIBLE_FOR_ONEPASS_MIGRATION_MSG
    };
  }

  if (isMicrofrontend) {
    if (paramMigrationStatus === "done") {
      var msg = paramMigrationDoubleSubs === "1" ? FLASH_BANNER_MIGRATION_SUCCESS_DOUBLE_SUB_MSG : FLASH_BANNER_MIGRATION_SUCCESS_MSG;
      emitMigrationFlashMessageImpression({
        type: "success",
        message: msg
      });
      return {
        theme: "dark",
        variant: "success",
        message: msg
      };
    } else if (paramMigrationStatus === "error") {
      emitMigrationFlashMessageImpression({
        type: "error",
        message: FLASH_BANNER_MIGRATION_ERROR_MSG
      });
      return {
        theme: "dark",
        variant: "error",
        message: FLASH_BANNER_MIGRATION_ERROR_MSG
      };
    }
  }

  return null;
};